import { AfterViewInit, Component, ElementRef, EventEmitter, inject, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DIMENSION_COLORS } from '../../constants';

@Component({
  selector: 'app-range',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './range.component.html',
  styleUrl: './range.component.scss'
})
export class RangeComponent {
  private renderer = inject(Renderer2);
  private elRef = inject(ElementRef);
  @ViewChild('range', { static: true }) rangeElement!: ElementRef<HTMLInputElement>;
  @ViewChild('rangeValue', { static: true }) rangeValueElement!: ElementRef<HTMLDivElement>;

  private _value = 0;
  private _index = 0;

  private colors = DIMENSION_COLORS

  @Input()
  set index(index: number) {
    this._index = index;
    this.apply();
  }
  get index(): number {
    return this._index;
  }

  @Input()
  set value(value: number) {
    this._value = value;
    this.apply();
  }
  get value(): number {
    return this._value;
  }
  @Output() onChange: EventEmitter<number> = new EventEmitter<number>();

  private apply() {
    const range: any = this.rangeElement.nativeElement;
    const rangeValue: any = this.rangeValueElement.nativeElement;

    const
      newValue = Number((this.value - range.min) * 100 / (range.max - range.min)),
      newPosition = 20 - (newValue * 0.5);

    rangeValue.innerHTML = `<span>${this.value}</span>`;
    rangeValue.style.left = `calc(${newValue}% + (${newPosition}px))`;

    const progress = (this.value / range.max) * 100;

    range.style.background = `linear-gradient(to right, ${this.colors[this.index]} ${progress}%, rgba(247, 247, 250, 1) ${progress}%)`;

    const hostElement = this.elRef.nativeElement;
    this.renderer.setProperty(hostElement, 'style', `--range-primary: ${this.colors[this.index]}`);

  }
  input() {
    this.onChange.emit(this.value);
  }

}
